let adPlaying = false;
let wasInFullscreen = false;

export default (newAdPlaying) => {
  if (adPlaying !== newAdPlaying) {
    adPlaying = newAdPlaying;
    const video = document.querySelector('video[class="player:video"]');
    if (video) {
      try {
        if (adPlaying) {
          wasInFullscreen = false;
          wasInFullscreen = video.webkitDisplayingFullscreen;
          if (wasInFullscreen) {
            video.webkitExitFullscreen();
          }
        } else if (wasInFullscreen) {
          // if ad stopped playing and video was in fullscreen before ad start
          video.webkitEnterFullscreen();
        }
      } catch {
        // no op
      }
    }
  }
};
